import styled from 'styled-components'

export const PaginatorWrapper = styled.div``
export const PageNumber = styled.a`
  width: 30px;
  height: 30px;
  font-size: 12px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  cursor: pointer;
  text-decoration: none;
  &.selected {
    color: #fff;
    background: #6327b7;
    border: none;
    pointer-events: none;
  }
  &:hover {
    color: #fff;
    background: #000;
  }
`
export const PageNumberList = styled.span`
  display: flex;
  gap: 10px;
`
export const PageChangeButtons = styled.span`
  width: 30px;
  height: 30px;
  color: #666;
  font-size: 22px;
  align-items: center;
  display: flex;
  justify-content: center;
  border: 1px solid #e3e3e3;
  cursor: pointer;
  &:hover {
    color: #fff;
    background: #000;
  }
  &.selected {
    pointer-events: none;
  }
`
export const PageControls = styled.div<{ isMobile: boolean }>`
  display: flex;
  gap: 10px;
  @media (max-width: 700px) {
    justify-content: center;
    padding-bottom: 20px;
  }
  ${props =>
    props.isMobile &&
    `
  @media (max-width: 1140px) {
    justify-content: center;
    padding-bottom: 20px;
  }
  `}
`
export const TotalPages = styled.span`
  float: right;
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
  color: #666;
  @media (max-width: 700px) {
    display: none;
  }
`
